import {Component, Inject, Output, EventEmitter} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { environment } from './../../../environments/environment';
export interface DialogData {
  popup: 'fetch-data' | 'success';
}


@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent{
  imgUrl = environment.imgUrl;
  index = 0;
  id;
  fetchData: boolean = true;
  success: boolean = false;
  btnAction = new EventEmitter();

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.showMessages();
  }
  
  messages = [
    "Checking your medications…",
    "Consolidating all your co-pays…",
    "Checking for any chronic conditions…",
    "Looking for any medical devices…",
    "Almost done, just few more minutes.."
  ];
  showMessages(){
    if(this.fetchData === true){
      setTimeout(()=>{
        this.id = setInterval(() => {
          if(this.index === 4){
            clearInterval(this.id);
            this.fetchData = false;
            this.success = true;
          }else{
            this.index++;
          }
        }, 2000);
      },300)
    }
  }
  getStartedBtnClick(){
    this.btnAction.emit();
  }
}
